import React from 'react';
import './v2_Icon.css';

const DEFAULT_VARIATION = "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20";

/**
 * Lightweight icon wrapper for UI v2.
 * Uses Material Symbols (font-based) loaded by v2_discovery/themecontrols/themecontrol.css.
 *
 * Sizes (optional — omit to use the base 16px default from CSS):
 * - sm: 16px
 * - md: 18px
 * - lg: 20px
 *
 * Color variants:
 * - success: green icon color
 * - danger: red icon color
 * - info: blue/info icon color
 * - warning: yellow/warning icon color
 * - inverse: inverse icon color for dark backgrounds
 * - muted: secondary/subtle icon color
 * - primary: default readable icon color
 */

function V2Icon({
  name,
  title,
  size,
  variant,
  className = '',
  style = {},
  variationSettings = DEFAULT_VARIATION,
}) {
  // Keep backward compatibility with older "invert" variant usage.
  const resolvedVariant = variant === 'invert' ? 'inverse' : variant;
  const classes = [
    'material-symbols-outlined',
    'v2-icon',
    size && `v2-icon--${size}`,
    resolvedVariant && `v2-icon--${resolvedVariant}`,
    className,
  ].filter(Boolean).join(' ');
  return (
    <span
      className={classes}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      title={title || undefined}
      style={{
        fontVariationSettings: variationSettings,
        ...style,
      }}
    >
      {name}
    </span>
  );
}

export default V2Icon;
